import { defineStore } from "pinia";

export const useConfigStore = defineStore("config", {
  state: () => ({
    remoteConfig: {
      bookmark_root_url: import.meta.env.VITE_BOOKMARK_ROOT_URL,
      admin_api_base: import.meta.env.VITE_ADMIN_API_BASE,
      cvd_api_base: import.meta.env.VITE_CVD_API_BASE,
      matomo_site_id: import.meta.env.VITE_MATOMO_SITE_ID,
      oidc_client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
      presignup_base: import.meta.env.VITE_PRESIGNUP_BASE,
      related_content_root_url: import.meta.env.VITE_RELATED_CONTENT_ROOT_URL,
      searchupdate_socket_base: import.meta.env.VITE_SEARCHUPDATE_SOCKET_BASE,
      sync_session_cookie_lifetime: import.meta.env
        .VITE_SYNC_SESSION_COOKIE_LIFETIME,
      comments_api_base: import.meta.env.VITE_COMMENTS_API_BASE,
      content_api_base: import.meta.env.VITE_CONTENT_API_BASE,
      desks_api_base: import.meta.env.VITE_DESKS_API_BASE,
      enable_matomo: import.meta.env.VITE_ENABLE_MATOMO,
      infokanal_socket_url: import.meta.env.VITE_INFOKANAL_SOCKET_URL,
      infokanal_api_base: import.meta.env.VITE_INFOKANAL_API_BASE,
      matomo_url: import.meta.env.VITE_MATOMO_URL,
      messages_socket_base: import.meta.env.VITE_MESSAGES_SOCKET_BASE,
      oidc_authority: import.meta.env.VITE_OIDC_AUTHORITY,
      sync_session_cookie_tld: import.meta.env.VITE_SYNC_SESSION_COOKIE_TLD,
      ydc_api_base: import.meta.env.VITE_YDC_API_BASE,
      disruption_info_socket_url: import.meta.env
        .VITE_DISRUPTION_INFO_SOCKET_URL,
      environment: import.meta.env.VITE_ENVIRONMENT,
      messages_api_base: import.meta.env.VITE_MESSAGES_API_BASE,
      savedsearch_api_base: import.meta.env.VITE_SAVEDSEARCH_API_BASE,
      intelligence_api_base: import.meta.env.VITE_INTELLIGENCE_API_BASE,
    },
    localConfig: {
      search: {
        maxResults: 10,
        autoRefreshTime: 1000 * 30, // 30 seconds
      },
      useMockServer: false,
    } as Record<string, any>,
  }),
});
